var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.367188 8.2085C0.367188 3.79022 3.94891 0.208496 8.36719 0.208496H37.4155C41.8338 0.208496 45.4155 3.79022 45.4155 8.2085V40.1946C45.4155 44.6129 41.8338 48.1946 37.4155 48.1946H8.36719C3.94891 48.1946 0.367188 44.6129 0.367188 40.1946V8.2085Z",
    fill: "#90AAD6",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1257 13.8918H17.1283C16.598 13.8918 16.0895 14.1025 15.7145 14.4775C15.3396 14.8524 15.1289 15.361 15.1289 15.8913V31.8866C15.1289 32.4169 15.3396 32.9255 15.7145 33.3004C16.0895 33.6754 16.598 33.8861 17.1283 33.8861H29.1249C29.6551 33.8861 30.1637 33.6754 30.5387 33.3004C30.9136 32.9255 31.1243 32.4169 31.1243 31.8866V18.8904L26.1257 13.8918Z",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.127 13.8918V17.8907C25.127 18.421 25.3376 18.9295 25.7126 19.3045C26.0875 19.6795 26.5961 19.8901 27.1264 19.8901H31.1252",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1289 20.8896H19.1289",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1266 24.8887H19.1289",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1266 28.8875H19.1289",
    stroke: "#092147",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.c5cbd93f2abc3ee2c478d6e6b071d02e.svg";
export { ForwardRef as ReactComponent };